import { render, staticRenderFns } from "./CharacterInfo.vue?vue&type=template&id=05d53215&"
import script from "./CharacterInfo.vue?vue&type=script&lang=js&"
export * from "./CharacterInfo.vue?vue&type=script&lang=js&"
import style0 from "./CharacterInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports